import { el, setAttr } from 'redom';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';

import keys from 'constants/keys';

class TextInput {

  constructor(options) {

    this.outsideEventRegistration = null;
    this.preventBlur = false;

    this.onChange = options.onChange;
    this.onClose = options.onClose;
    this.onEnterKey = options.onEnterKey;

    this.input = el('input.customers-filter-text-input-field', {
      placeholder: options.placeholder,
      value: this.getNormalizedValue(options.value),
      type: options.type,
      onkeydown: this.handleInputKeyDownEvent.bind(this),
      onkeyup: this.handleInputKeyUpEvent.bind(this),
      onblur: this.handleBlurEvent.bind(this)
    });
    this.input.previousValue = '';

    this.el = el('.customers-filter-text-input-main', [this.input]);

  }

  onmount() {

    this.registerOutsideEventHandler();

  }

  onunmount() {

    this.unregisterOutsideEventHandler();

  }

  getNormalizedValue(value) {

    if (Array.isArray(value) === true) {

      if (value.length > 0) {
        return value[0].key;
      }

      return '';

    }

    return value.key;

  }

  handleInputKeyDownEvent(event) {

    const key = event.key;

    if (key === keys.ENTER) {
      this.preventBlur = true;
      this.onEnterKey();
    } else if (key === keys.ESCAPE) {
      this.onClose();
    }

  }

  handleInputKeyUpEvent(event) {

    const previousValue = this.input.previousValue;
    const newValue = this.input.value;

    if (previousValue === newValue) {
      return;
    }

    this.input.previousValue = newValue;

    this.onChange(newValue);

  }

  handleBlurEvent() {

    if (this.preventBlur === true) {
      this.preventBlur = false;
      return;
    }

    this.onClose();

  }

  focus() {

    this.input.focus();

    if (this.input.type === TextInput.types.DATE) {
      this.input.showPicker();
    }

  }

  setValue(value) {

    setAttr(this.input, {
      value: value.label
    });

  }

  outsideClickHandler(clickTargetElement) {

    this.onClose();

  }

  registerOutsideEventHandler() {

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.outsideClickHandler.bind(this));

  }

  unregisterOutsideEventHandler() {

    this.outsideEventRegistration.cancel();

  }

}

TextInput.types = {
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date'
};

export default TextInput;